import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ROLE, PROJECT, API_PREFIX } from '@/constants';
import { getProjectByid } from '@/services/modules/project';
import { message } from 'ant-design-vue';
import { router } from '@/router';

// export interface Project {
//   id: string;
//   projectTitle: string;
//   officeId: string;
//   dischargesId: number;
//   projectStatus: string;
//   memo: string;
//   type: string;
//   discharges: {};
//   pwasteIndustries: pwasteIndustry[];
//   pwasteRegulars: [];
//   office: {};
//   pFiles: {};
// }

// export type pwasteIndustry = {
//   waste: {
//     id: number;
//     name: string;
//   };
// };

// type WasteRegular = {
//   wasteRegularType: string;
//   capacity: number;
//   bag: { [key: string]: number };
//   frequency: { [key: string]: any };
//   expectedPrice: number;
// };
// const projectDefault = {
//   id: '',
//   projectTitle: '',
//   officeId: '',
//   office: {},
//   dischargesId: 0,
//   discharges: {},
//   pwasteIndustries: [],
//   pwasteRegulars: [],
//   projectStatus: PROJECT.STATUS.REQUEST_QUOTE,
//   memo: ''
// };
// export interface Waste {
//   id: number;
//   wasteCode: string;
//   name: string;
//   parentId: number;
//   path: string;
//   level: string;
// }

export const useProjectStore = defineStore('project', () => {
  const prefixApi = ref('');
  // const projects = ref<Project[]>([]);
  const filters = ref([]);
  // const project = ref<Project>({
  //   id: '',
  //   projectTitle: '',
  //   officeId: '',
  //   office: '',
  //   dischargesId: 0,
  //   projectStatus: '',
  //   memo: '',
  //   type: '',
  //   discharges: {},
  //   pwasteIndustries: [],
  //   pwasteRegulars: [],
  //   pFiles: {}
  // });
  // const selectedStatus = ref<string | null>(null);
  // const selectedType = ref<string | null>(null);
  // const statusList = ref<string[] | null>(null);
  // const query = ref<string | null>(null);
  // const wastesRegular = ref<WasteRegular[] | null>(null);
  // const lastLevel = ref('');
  // const wasteArraySelected = ref<Waste[]>();

  const fetchPrefix = (roles: string[]) => {
    roles.forEach((role) => {
      switch (role) {
        case ROLE.TRANSPORT:
        case ROLE.ADMIN:
          prefixApi.value = API_PREFIX.TRANSPORT;
          break;
        default:
          break;
      }
    });
  };

  // const setSelectedStatus = (status: string | null) => {
  //   selectedStatus.value = status;
  // };

  // const setStatusList = (list: string[]) => {
  //   statusList.value = list;
  // };

  // const setSelectedType = (type: string | null) => {
  //   selectedType.value = type;
  // };

  // const setQuery = (q: string | null) => {
  //   query.value = q;
  // };

  // const initProject = (type: string) => {
  //   project.value = { ...projectDefault, type };
  // };

  // const initProjectIndustry = (projectIndustryInit: any) => {
  //   project.value = projectIndustryInit;
  // };

  // const fetchProject = async (id: string) => {
  //   try {
  //     const response: any = await getProjectByid(prefixApi.value, id);
  //     if (response.status) {
  //       const regex = /^20[0-9]$/;
  //       if (regex.test(response.status.toString())) {
  //         project.value = response.data;
  //       }
  //     }
  //   } catch (e) {
  //     message.error(t('not_found'));
  //     router.push({ name: 'ProjectManagement' });
  //   }
  // };

  return {
    // project,
    // projects,
    filters,
    // statusList,
    // selectedStatus,
    // wastesRegular,
    prefixApi,
    // wasteArraySelected,

    fetchPrefix
    // setSelectedStatus,
    // setSelectedType,
    // setQuery,
    // setStatusList,
    // initProject,
    // fetchProject,
    // lastLevel,
    // initProjectIndustry
  };
});
